import { Link } from "react-router-dom";
import Tag from "../Tag";

const BlogItem = ({ blog }) => {
    const { id, title, image, tags, likes, isSaved, createdAt } = blog || {};

    return (
        <div className="lws-card">
            <Link to={`/post/${id}`}>
                <img src={image} className="lws-card-image" alt={title} />
            </Link>
            <div className="p-4">
                <div className="lws-card-header">
                    <p className="lws-publishedDate">{createdAt}</p>
                    <p className="lws-likeCount">
                        <i className="fa-regular fa-thumbs-up"></i>
                        {likes}
                    </p>
                </div>
                <Link to={`/post/${id}`} className="lws-postTitle">
                    {title}
                </Link>
                <div className="lws-tags">
                    {tags?.map((tag, i) => (
                        <Tag
                            key={i}
                            tag={tag}
                            index={i}
                            length={tags?.length}
                        />
                    ))}
                </div>
                {isSaved && (
                    <div className="flex gap-2 mt-4">
                        <span className="lws-badge"> Saved </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogItem;
